(() => {
  if (window.RR) return;
  const readJson = (selector, fallback, root = document) => {
    try { return JSON.parse(root.querySelector(selector)?.textContent || "null") || fallback; }
    catch { return fallback; }
  };
  const config = readJson('[data-rr-home-config]', {});
  const currentStrings = () => readJson('[data-rr-home-config]', config).strings || {};
  const translate = (key, replacements = {}) => Object.entries(replacements).reduce(
    (value, [name, replacement]) => value.replaceAll(`{${name}}`, String(replacement)), currentStrings()[key] || key
  );
  const ICONS = {
    arrow: '<path d="M4 12h15M13 6l6 6-6 6"/>',
    diamond: '<path d="M6 4h12l4 5-10 11L2 9z"/><path d="M2 9h20M9 4l3 5 3-5M9 9l3 11 3-11"/>',
    truck: '<path d="M2 6h11v10H2zM13 10h4.5L21 13.5V16h-8z"/><circle cx="6" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/>',
    support: '<path d="M4 13v-1a8 8 0 0 1 16 0v1"/><path d="M4 13h3v5H5a1 1 0 0 1-1-1zM20 13h-3v5h2a1 1 0 0 0 1-1z"/><path d="M17 18c0 1.6-1.8 2.5-5 2.5"/>',
    shield: '<path d="M12 3l8 3v6c0 4.5-3.3 8-8 9-4.7-1-8-4.5-8-9V6z"/><path d="M8.5 12l2.5 2.5 4.5-5"/>',
    returns: '<path d="M4 9h11a5 5 0 0 1 0 10H9"/><path d="M8 5L4 9l4 4"/>',
    play: '<path d="M8 5.5v13l11-6.5z"/>',
    rotate: '<path d="M20 12a8 8 0 1 1-2.3-5.7"/><path d="M20 4v4h-4"/>',
    bag: '<path d="M5 8h14l-1 12H6z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/>',
    menu: '<path d="M4 7h16M4 12h16M4 17h16"/>',
    close: '<path d="M6 6l12 12M18 6L6 18"/>',
    check: '<path d="M5 12.5l4.5 4.5L19 7"/>',
    chat: '<path d="M4 5h16v11H9l-5 4z"/>',
    ruler: '<path d="M3 16L16 3l5 5L8 21z"/><path d="M7 12l2 2M10 9l2 2M13 6l2 2"/>',
    certificate: '<path d="M5 3h14v13H5z"/><path d="M8 7h8M8 10h5"/><circle cx="15.5" cy="17.5" r="2.5"/><path d="M14 19.5V22l1.5-1 1.5 1v-2.5"/>',
    spark: '<path d="M12 3v5M12 16v5M3 12h5M16 12h5M6 6l2.5 2.5M15.5 15.5L18 18M18 6l-2.5 2.5M8.5 15.5L6 18"/>',
    mail: '<path d="M3 5h18v14H3z"/><path d="M3 6l9 7 9-7"/>',
    phone: '<path d="M5 3h4l2 5-2.5 1.5a11 11 0 0 0 6 6L16 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 5a2 2 0 0 1 2-2z"/>',
    chevron: '<path d="M6 9l6 6 6-6"/>',
    search: '<circle cx="11" cy="11" r="6.5"/><path d="M16 16l4.5 4.5"/>',
    plus: '<path d="M12 5v14M5 12h14"/>',
    user: '<circle cx="12" cy="8.5" r="3.8"/><path d="M4.5 20.5c1.2-3.8 4-5.6 7.5-5.6s6.3 1.8 7.5 5.6"/>',
  };

  function icon(name, cls = "") {
    return `<svg class="icon ${cls}" viewBox="0 0 24 24" aria-hidden="true">${ICONS[name] || ""}</svg>`;
  }

  const SHAPE_PATHS = {
    Round: '<circle cx="20" cy="24" r="15"/><path d="M20 9l6 9 9 6-9 6-6 9-6-9-9-6 9-6z"/><path d="M14 18h12v12H14z"/>',
    Oval: '<ellipse cx="20" cy="24" rx="12" ry="18"/><path d="M20 6l5 11 7 7-7 7-5 11-5-11-7-7 7-7z"/>',
    Emerald: '<path d="M13 5h14l5 5v28l-5 5H13l-5-5V10z"/><path d="M15 10h10l3 3v22l-3 3H15l-3-3V13z"/><path d="M18 15h4l1 1v16l-1 1h-4l-1-1V16z"/>',
    Cushion: '<rect x="7" y="7" width="26" height="34" rx="9"/><path d="M20 7l5 9 8 8-8 8-5 9-5-9-8-8 8-8z"/>',
    Radiant: '<path d="M12 6h16l5 5v26l-5 5H12l-5-5V11z"/><path d="M12 6l8 18 8-18M12 42l8-18 8 18M7 11l13 13 13-13M7 37l13-13 13 13"/>',
    Pear: '<path d="M20 5C13 14 8 22 8 30a12 12 0 0 0 24 0c0-8-5-16-12-25z"/><path d="M20 5l-4 17-8 8M20 5l4 17 8 8M16 22l4 20 4-20"/>',
    Marquise: '<path d="M20 4c9 8 12 14 12 20s-3 12-12 20C11 36 8 30 8 24s3-12 12-20z"/><path d="M20 4v40M8 24h24M20 14l6 10-6 10-6-10z"/>',
    Princess: '<path d="M7 11h26v26H7z"/><path d="M7 11l26 26M33 11L7 37M20 11v26M7 24h26"/>',
    Asscher: '<path d="M14 11h12l7 7v12l-7 7H14l-7-7V18z"/><path d="M16 15h8l5 5v8l-5 5h-8l-5-5v-8z"/><path d="M18 19h4l3 3v4l-3 3h-4l-3-3v-4z"/>',
    "Old cut": '<rect x="8" y="10" width="24" height="28" rx="7"/><circle cx="20" cy="24" r="4"/><path d="M20 10v10M20 28v10M8 24h8M24 24h8M11 13l6 8M29 13l-6 8M11 35l6-8M29 35l-6-8"/>',
  };

  function shapeSvg(shape, cls = "shape-ico") {
    const d = SHAPE_PATHS[shape];
    if (!d) return "";
    return `<svg class="${cls}" viewBox="0 0 40 48" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.1" stroke-linejoin="round">${d}</svg>`;
  }

  function esc(value) {
    return String(value ?? "").replace(/[&<>"']/g, (character) => ({"&":"&amp;", "<":"&lt;", ">":"&gt;", '"':"&quot;", "'":"&#39;"})[character]);
  }
  let formatter;
  try {
    formatter = new Intl.NumberFormat(config.locale || document.documentElement.lang || 'en', { style: 'currency', currency: config.currency || 'AUD' });
  } catch {
    formatter = new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' });
  }
  const price = (cents) => formatter.format(Number(cents) / 100);
  function imgSrc(src, width) {
    if (!src) return '';
    try { const url = new URL(src, location.href); url.searchParams.set('width', String(width)); return url.href; }
    catch { return ''; }
  }
  const shapeFor = (title) => {
    if (/old[ -](mine|european|cut)/i.test(title)) return 'Old cut';
    return ['Marquise','Princess','Asscher','Emerald','Radiant','Cushion','Oval','Round','Pear'].find(shape => new RegExp(`\\b${shape}\\b`, 'i').test(title)) || '';
  };
  const familyFor = (title) => {
    const match = title.match(/\b(Altara|Forma|Solara|Aster|Veyra|Penumbra)\b/i);
    if (match) return match[1][0].toUpperCase() + match[1].slice(1).toLowerCase();
    if (/half[ -]bezel/i.test(title)) return 'Half Bezel';
    if (/thin.*simple/i.test(title)) return 'Thin + Simple';
    return '';
  };
  const catalog = (root = document) => readJson('#rr-catalog-data', [], root).map(product => ({...product, shape: shapeFor(product.t), fam: familyFor(product.t)}));
  const productUrl = (product) => product.url || `${window.Shopify?.routes?.root || '/'}products/${encodeURIComponent(product.h)}`;
  const shapeLabel = (shape) => currentStrings()[`shape_${shape.toLowerCase().replaceAll(' ', '_')}`] || shape;
  function lotLabel(parts) { return `<span class="lot">${parts.filter(Boolean).map(part => `<span>${esc(part)}</span>`).join('')}</span>`; }
  function card(product) {
    const [first, second] = product.img || [];
    const media = first ? `<img src="${esc(imgSrc(first, 600))}" alt="${esc(product.t)}" loading="lazy" decoding="async" width="700" height="700">${second ? `<img src="${esc(imgSrc(second, 600))}" alt="" loading="lazy" decoding="async" width="700" height="700">` : ''}` : '';
    return `<a class="card card--linked" href="${esc(productUrl(product))}" aria-label="${esc(product.t)}"><div class="card-media">${media}</div>${lotLabel([shapeLabel(product.shape || ''),product.fam])}<h3>${esc(product.t)}</h3><p class="card-price num">${esc(translate('from'))} <b>${esc(product.priceText || price(product.min))}</b></p><p class="card-fit">${esc(translate('all_options'))}</p></a>`;
  }
  function hydrateIcons(root = document) {
    root.querySelectorAll('[data-icon]').forEach(element => { element.outerHTML = icon(element.dataset.icon, element.className); });
    root.querySelectorAll('[data-shape]').forEach(element => { element.outerHTML = shapeSvg(element.dataset.shape, element.className || 'shape-ico'); });
  }
  function initHeader(root = document) {
    const button = root.querySelector('.menu-btn');
    const navigation = root.querySelector('#mobile-nav');
    if (!button || !navigation || button.dataset.rrInitialized) return;
    button.dataset.rrInitialized = 'true';
    const close = () => { navigation.classList.remove('open'); button.setAttribute('aria-expanded', 'false'); button.innerHTML = icon('menu'); };
    button.addEventListener('click', () => {
      const open = navigation.classList.toggle('open');
      button.setAttribute('aria-expanded', String(open));
      button.innerHTML = icon(open ? 'close' : 'menu');
    });
    navigation.addEventListener('click', event => { if (event.target.closest('a')) close(); });
    document.addEventListener('keydown', event => { if (event.key === 'Escape' && navigation.classList.contains('open')) { close(); button.focus(); } });
    document.addEventListener('click', event => { if (!navigation.contains(event.target) && !button.contains(event.target)) close(); });
    const header = button.closest('.site-header');
    if (header) {
      const update = () => header.classList.toggle('is-solid', window.scrollY > 40);
      addEventListener('scroll', update, {passive:true}); update();
    }
  }
  function initialize(root = document) {
    hydrateIcons(root); initHeader(root);
    root.querySelectorAll('[data-year]').forEach(element => { element.textContent = String(new Date().getFullYear()); });
  }
  window.RR = { icon, shapeSvg, price, imgSrc, esc, catalog, productUrl, lotLabel, card, hydrateIcons, translate, shapeLabel };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), {once:true});
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
